import {useState} from "react";
import {Table, Tag, Input, Button, message} from "antd";
import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import {useTraceRedirectMutation} from "~/reduxs/api/technicalApiSlice";
import {UrlLink, StatusTag, fmt} from "./TechShared";
import {rtkErrorMessage} from "~/reduxs/api/apiSlice";
import style from "../style/Technical.module.scss";

const cn = className.bind(style);

/**
 * Chuyển hướng: công cụ NHẬP URL LẺ để trace chuỗi redirect trực tiếp (HTTP thật) + bảng
 * các trang có chuyển hướng phát hiện khi crawl (chuỗi >1 bước được đánh dấu).
 */
function TechRedirects({projectId, redirects = []}) {

	const [url, setUrl] = useState('');
	const [trace, setTrace] = useState(null);
	const [traceRedirect, {isLoading}] = useTraceRedirectMutation();

	const onTrace = async () => {
		if (!url.trim()) return;
		try {
			const res = await traceRedirect({projectId, url: url.trim()}).unwrap();
			setTrace(res);
		} catch (e) {
			message.error(rtkErrorMessage(e, 'Không trace được URL này.'));
		}
	};

	const columns = [
		{title: 'Trang', dataIndex: 'url', ellipsis: true, render: (u) => <UrlLink url={u} />},
		{title: 'Chuyển hướng tới', dataIndex: 'to', ellipsis: true, render: (u) => <UrlLink url={u} />},
		{
			title: 'Số bước', dataIndex: 'hops', width: 130, align: 'center',
			render: (h, r) => (r.chain ? <Tag color="volcano">{h} bước (chuỗi)</Tag> : <Tag color="gold">{h} bước</Tag>),
		},
	];

	return (
		<div className={cn('tab')}>
			<h4 className={cn('sectionTitle')}>Kiểm tra chuyển hướng một URL</h4>
			<div className={cn('traceForm')}>
				<Input
					placeholder="https://example.com/duong-dan"
					value={url}
					onChange={(e) => setUrl(e.target.value)}
					onPressEnter={onTrace}
					allowClear
				/>
				<Button type="primary" loading={isLoading} onClick={onTrace}>Trace</Button>
			</div>

			{trace && (
				<div className={cn('traceResult')}>
					{trace.loop && (
						<div className={cn('traceLoop')}>
							<FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" /> Phát hiện vòng lặp chuyển hướng (redirect loop)!
						</div>
					)}
					<div className={cn('chain')}>
						{(trace.chain || []).map((step, i) => (
							<div key={i} className={cn('chainStep')}>
								<StatusTag status={step.status} />
								<UrlLink url={step.url} />
								{i < trace.chain.length - 1 && <FontAwesomeIcon icon="fa-solid fa-arrow-down" className={cn('chainArrow')} />}
							</div>
						))}
					</div>
					<div className={cn('muted')}>
						Tổng {trace.hops} lần chuyển hướng — đích cuối: HTTP {trace.final_status}.
					</div>
				</div>
			)}

			<h4 className={cn('sectionTitle')} style={{marginTop: 24}}>Chuyển hướng phát hiện khi crawl ({fmt(redirects.length)})</h4>
			<Table size="small" rowKey={(r) => r.url} columns={columns} dataSource={redirects}
				scroll={{x: 'max-content'}} pagination={{pageSize: 15, hideOnSinglePage: true}} />
		</div>
	);
}

export default TechRedirects;
